/*收款
i:get || post
h:requestGet ||requestPost
*/
import axios from '../axios'
export default {
    orderDetails: (id) => axios.get('/api/api/agile_collect/' + id),//获取订单数据详情
    agiLes: (data) => axios.requestPost('/v1/ucentor/agiles/order', data),//点击购买
    productList: (data) => axios.get('/api/api/status-promote', data),//购买成功页-推荐产品
    getAnotherPay: (data) => axios.get('/api/api/payment/another/verfiy/payment', data),//他人代付页
    getAnotherProfile: (data) => axios.get('/api/api/payment/another/profile', data),//他人代付页
    putAnotherCancel: (data) => axios.put('/api/api/payment/another/cancel', data),//他人代付页
}